import React from 'react'
import { Row, Col } from 'antd'

import { objectify } from 'lib/utils'
import InventoryResourceContainer from '../../../container'
import InventoryTags from 'containers/inventory/shared/tags'
import KinesisFirehoseMetadata from './metadata'
import Events from 'containers/inventory/shared/events'
import { INVENTORY_SERVICES } from 'lib/resources/constants'
import { KINESIS_FIREHOSE_INCOMING } from '../../../metrics-tabs/services/kinesis-firehose'
import Section from 'components/layout/content/section'
import Tabs from 'components/antd/tabs'

const Config = ({ item }) => {
  const attributes = objectify(item?.attributes)

  return (
    <>
      {item?.tags?.length !== 0 && <InventoryTags tags={item.tags} inverse />}
      <KinesisFirehoseMetadata attributes={attributes} inverse />
    </>
  )
}

const KinesisFirehoseDeliveryStream = ({ item }) => {
  return (
    <>
      <InventoryResourceContainer item={item} service={INVENTORY_SERVICES.KinesisFirehose.id} initialChart={KINESIS_FIREHOSE_INCOMING}>
        <Row gutter={12}>
          <Col xs={24} md={16}>
            <Section>
              <Tabs defaultActiveKey="configuration" items={[{ key: 'configuration', label: 'Configuration', children: <Config item={item} /> }]} />
            </Section>
          </Col>
          <Col xs={24} md={8}>
            <Events resourceId={item.id} />
          </Col>
        </Row>
      </InventoryResourceContainer>
    </>
  )
}

export default KinesisFirehoseDeliveryStream
